import { render, staticRenderFns } from "./tooltip-box.vue?vue&type=template&id=65f0a84a&scoped=true"
import script from "./tooltip-box.vue?vue&type=script&lang=js"
export * from "./tooltip-box.vue?vue&type=script&lang=js"
import style0 from "./tooltip-box.vue?vue&type=style&index=0&id=65f0a84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0a84a",
  null
  
)

export default component.exports